(function() {
  'use strict';

  window.Coop = window.Coop || { Modules: {} };

  Coop.Modules.AppHeight = {
    init: function() {
      this.bindEvents();
      this.fitLayout();
    },
    bindEvents: function() {
      var self = this;

      $(window)
        .off('resize.AppHeight')
        .on('resize.AppHeight', function(){
          self.fitLayout();
        });
    },
    fitLayout: function() {
      var mapHeight;
      var $extras = $('.header-extras');

      if (this.isMobileView()) {
        this.resetHeight($('#main, .finder-results-list'));

        if (!$('body').hasClass('list-view')) {
          mapHeight = this.windowHeight() - this.bottomOffset($('.finder-form'));

          if ($extras.length) {
            mapHeight = mapHeight - $extras.outerHeight();
          }

          this.setHeight($('.finder-map'), mapHeight, 'height');
        }

        if($('.store-item-clone:hidden')) {
          $('.store-item-clone').show();
        }
      }
      else {
        this.hideStorePanel();
        this.resetHeight($('.finder-map'));

        // Disabled to match the new design of a large map
        // Leaving in case design decision changes again
        //this.setHeight($('#main'), mapHeight, 'height');

        if ($('body').hasClass('finder-landing')) {
          this.resetHeight($('.finder-results-list'));
        }
        else {
          // Disabled to match the new design of a large map
          // Leaving in case design decision changes again
          //var topOffset = parseInt($('.finder-wrap').css('padding-top')) || 0;
          //this.setHeight($('.finder-results-list'), mapHeight - ($('.finder-form').outerHeight()), 'max-height');
        }
      }
    },
    setHeight: function($el, height, property) {
      $el.css(property, height);

      if ($el.hasClass('finder-map') && typeof locationsMap !== 'undefined') {
        google.maps.event.trigger(locationsMap.mapElement, "resize");
        locationsMap.resetBounds();
      }
    },
    resetHeight: function($el) {
      $el.css({maxHeight: '', height: ''});
    },
    windowHeight: function() {
      return $(window).height();
    },
    bottomOffset: function($el) {
      if (!$el.length) {
        return 0;
      }

      return $el.offset().top + $el.outerHeight();
    },
    isMobileView: function() {
      return $(window).width() < 750;
    },
    isDesktopView: function() {
      return !this.isMobileView();
    },
    hideStorePanel: function(){
      $('.store-item-clone').hide();
    }
  };
}());
